import Button from 'react-bootstrap/Button';
import AWS from 'aws-sdk'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useDispatch } from 'react-redux';
import { uplodateLoading } from '../../../redux/features/common/commonSlice';

export const AddCategory = props => {
    const dispatch = useDispatch()
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [imageFile, setImageFile] = useState(null)
    const [selectedImage, setSelectedImage] = useState(null)
    const [error, setError] = useState({
        productId: false,
        storeType: false,
        amount: false,
        chips: false,
        description: false,
    });

    // Handle the image selection
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setSelectedImage(URL.createObjectURL(file));
        }
    };

    const uploadFile = async assetFile => {
        // S3 Bucket Name
        const S3_BUCKET = 'praxo-dev-cloud-front'

        // S3 Region
        const REGION = 'ap-south-1'

        // S3 Credentials
        AWS.config.update({
            accessKeyId: 'AKIA4MTWJYJHQ6U6YWFK',
            secretAccessKey: '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'
        })
        const s3 = new AWS.S3({
            params: { Bucket: S3_BUCKET },
            region: REGION
        })
        // Files Parameters
        const fileName = 'help-category-images/' + assetFile?.name
        console.log(fileName)
        const params = {
            Bucket: S3_BUCKET,
            Key: fileName,
            Body: assetFile
        }

        // Uploading file to s3

        var upload = await s3
            .putObject(params)
            .on('httpUploadProgress', evt => {
                console.log(
                    'Uploading ' + parseInt((evt.loaded * 100) / evt.total) + '%'
                )
                setUploadPercentage(parseInt((evt.loaded * 100) / evt.total))
            })
            .promise()
        return 'https://dhwdwg726vpm7.cloudfront.net/' + fileName
    }

    const handleSubmit = async () => {
        let categoryIcon;
        if (imageFile) {
            dispatch(uplodateLoading(true))
            categoryIcon = await uploadFile(imageFile)
        }
        props?.setCategoryFormData({
            ...props?.categoryFormData,
            icon: categoryIcon
        })
        props?.onSubmit()
    };

    return (
        <Modal
            {...props}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    {props?.categoryFormData?.id ? 'Update Category' : 'Add Category'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row'>
                    <div className='col-md-6'>
                        <Form.Group controlId='productId'>
                            <h4>Name*</h4>
                            <Form.Control
                                type='text'
                                maxLength={20}
                                placeholder='Name'
                                value={props.categoryFormData.name}
                                onChange={e => props.setCategoryFormData({ name: e.target.value })}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-md-6'>
                        <Form.Group controlId='productId'>
                            <h4>Icon*</h4>
                            <input type='file' accept="image/png"
                                onChange={handleImageChange} />
                        </Form.Group>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='outlined' onClick={props?.onHide}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
};
